<template>
	<div class="admin-sidebar-holder" ref="sidebar">
		<div class="admin-sidebar-overlay" ref="overlay" @click="closeSidebar" :class="sidebarOpen ? classActive : ''"></div>
		<a class="site-header__admin-mobile menu-btn" ref="hamburger" :isActive="sidebarOpen" @click="toggleMenu"><span></span></a>
		<div class="admin-sidebar" :class="sidebarOpen ? classActive : ''">
			<div class="admin-sidebar__inner">
				<ul class="admin-sidebar-list">
					<li class="admin-sidebar-list-item"
						v-for="linkItem in checkPermissions() ? superSideBar : adminSideBar"
						:key="linkItem.id"
						@click="closeSidebar()"
						:class="linkItem.classItem"
						>
						<router-link v-if="linkItem.url.name" class="admin-sidebar-item__link admin-sidebar-list-item__link" :to="linkItem.url" :class="{'is-active': subIsActive([`/${linkItem.label.toLowerCase()}`])}">
							<div class="admin-sidebar-icon-holder">
								<SvgIcon class="admin-sidebar-list-item__icon admin-sidebar-icon" :class="linkItem.class" :iconName="linkItem.iconMenuItem" />
							</div>
							<span class="admin-sidebar-title admin-sidebar-list-item__title">{{ linkItem.label }}</span>
						</router-link>

						<a v-else class="admin-sidebar-item__link admin-sidebar-list-item__link admin-sidebar-list-item__link--drop" @click="toggleSubMenu" :class="{'is-active': showSubMenu }">
							<div class="admin-sidebar-icon-holder">
								<SvgIcon class="admin-sidebar-list-item__icon admin-sidebar-icon" :class="linkItem.class" :iconName="linkItem.iconMenuItem" />
							</div>
							<span class="admin-sidebar-title admin-sidebar-list-item__title">{{ linkItem.label }}</span>
						</a>

						<ul class="admin-sidebar-list admin-sidebar-list--sub" v-if="linkItem.linkItemSub && showSubMenu">
							<li v-for="(linkItemSub, index) in linkItem.linkItemSub" :key="index">
								<router-link class="admin-sidebar-item__link admin-sidebar-list-item__link" :to="linkItemSub.url" :class="{'is-active': subIsActive([`/${linkItemSub.label.toLowerCase()}`])}">
									<div class="admin-sidebar-icon-sub-item">
									</div>
									<span class="admin-sidebar-title admin-sidebar-list-item__title">{{ linkItemSub.label }}</span>
								</router-link>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon.vue';
import { check } from '@/services/RouteGuards/SuperAdmin';

export default {
	computed: {
		adminSideBar() {
			return this.$store.getters.getAdminSideBar;
		},
		superSideBar() {
			return this.$store.getters.getSuperSideBar;
		}
	},

	components: {
		SvgIcon
	},

	data () {
		return {
			showSubMenu: false,
			sidebarOpen: false,
			classActive: 'open',
			classScroll: 'prevent-scroll',
			classHamburger: 'open'
		};
	},
	methods: {
		toggleSubMenu() {
			this.showSubMenu = !this.showSubMenu;
		},
		closeSidebar() {
			if (this.sidebarOpen === true) {
				this.sidebarOpen = false;
				this.$refs.hamburger.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
				this.$refs.hamburger.classList.remove(this.classHamburger);
			}
		},
		toggleMenu() {
			this.sidebarOpen = !this.sidebarOpen;

			if (this.sidebarOpen) {
				this.$refs.hamburger.parentNode.parentNode.parentNode.classList.add(this.classScroll);
				this.$refs.hamburger.classList.add(this.classHamburger);
			} else {
				this.$refs.hamburger.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
				this.$refs.hamburger.classList.remove(this.classHamburger);
			}
		},
		closeDropdown() {
			if (this.sidebarOpen === true) {
				this.sidebarOpen = false;
			}
		},
		subIsActive(input) {
			const paths = Array.isArray(input) ? input : [input];
			return paths.some(path => {
				return this.$route.path.indexOf(path) === 6;
			});
		},
		checkPermissions() {
			return check();
		}
	}
};
</script>

<style lang="scss" scoped>
.admin-sidebar-icon-sub-item {
	height: 10px;
	width: 10px;
	background-color: #5E6C84;
	border-radius: 50%;
	display: inline-block;
	margin-right: 15px;
}

.admin-sidebar-list--sub {
	.admin-sidebar-item__link {
		padding-left: 30px;
	}
}
.admin-sidebar-holder {
	max-width: 15%;
	flex: 0 0 15%;

	@include mq($xl) {
		max-width: auto;
		flex: 0 0 auto;
	}
}
    .admin-sidebar {
        min-height: 100%;
        max-height: 100vh;
        padding: 0;
        background-color: $white;
		box-shadow: 5px 0 20px 0 rgba(208, 226, 246, 0.50);
        z-index: 99999;
        overflow: hidden;
        transform: translateX(-100%);
        transition: $dur $ease;

		position: fixed;
        top: 84px;
        left: 0;

		@include mq($xl) {
			top: 60px;
			min-height: 100vh;
			&.open {
                transform: translateX(0);
                min-width: 226px;
            }
		}

        @include mq($xl + 1, min) {
            max-width: 240px;
            display: block;
            transform: translateX(0);
        }
    }

    .admin-sidebar__inner {
        min-width: 240px;
    }

    .admin-sidebar-logo-holder {
        margin-bottom: 27px;
        padding: 0 12px;

        @include mq($xl) {
            margin-bottom: 15px;
        }
    }

    .admin-sidebar-logo {
        margin-right: 12px;
        width: 190px;
        max-width: 190px;
    }

    .admin-sidebar-logo-holder {
        display: flex;
        align-items: center;
    }

    .admin-sidebar-logo-title {
        font-weight: 400;
        font-size: 16px;
        color: $white;
        letter-spacing: 0.08px;
        line-height: 1;
        transition: $dur $ease;
    }

    .admin-sidebar-item__link {
        display: flex;
        align-items: center;
        padding: 22px 15px;
		transition: $dur $ease;
		position: relative;
		text-decoration: none;

		@include mq($xl) {
			padding: 14px 20px;
		}

		@include hover {
			.admin-sidebar-list-item__icon,
			.admin-sidebar-title {
				color: $dodger-blue;
				text-decoration: none;
			}
		}

		&.router-link-exact-active {
			background-color: $white;

			.admin-sidebar-list-item__icon,
			.admin-sidebar-title {
				color: $dodger-blue;
				text-decoration: none;
			}
		}
    }

    .admin-sidebar-item__link--disabled {
        pointer-events: none;
    }

    .admin-sidebar-list-item { 
        position: relative;
        //cursor: not-allowed;
    }

    .admin-sidebar-icon-holder {
        margin-right: 4px;
        width: 37px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        @include mq($lg) {
            width: 30px;
            margin-right: 15px;
        }
    }

    .admin-sidebar-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .admin-sidebar-icon-num {
        font-size: 10px;
        color: $white;
        font-weight: 400;
        letter-spacing: 0.05px;
        line-height: 1;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        z-index: 1;
        top: -10px;
        right: 2px;
    }

    .admin-sidebar__new {
        cursor: pointer;
    }

    .admin-sidebar__new-icon {
        height: 37px;
        width: 37px;
        border-radius: 4px;
        background-color: $shuttle-gray;
        color: $white;

        @include mq($lg) {
            font-size: 14px;
            height: 30px;
            width: 30px;
        }
    }

    .admin-sidebar__new-link {
        margin-bottom: 6px;

        @include mq($lg) {
            margin-bottom: 0;
        }
    }

    .admin-sidebar-title {
		font-family: $font-main;
		font-size: 16px;
		line-height: 1.4;
		color: $shuttle-gray;
        transition: $dur $ease;

        @include mq($lg) {
            font-size: 15px;
        }
    }

    .admin-sidebar-new--title {
        font-weight: 600;
    }

    .admin-sidebar-list-item__icon {
        font-size: 24px;
		height: 24px;
        color: $shuttle-gray;
        transition: 0.2s ease-in-out;

        @include mq($lg) {
            font-size: 20px;
        }
    }

    .sidebar-ps {
        height: calc(100vh - 107px);
        padding-bottom: 30px;
    }

    .admin-sidebar-overlay {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba($white, 0.7);
        z-index: 30;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: $dur $ease;

        &.open {
            opacity: 1;
            visibility: visible;
            pointer-events: all;
        }
    }

	.icon-sm {
		font-size: 18px;

		@include mq($sm) {
			font-size: 16px;
		}
	}

    /*--------------------------------------------------------------
	## Hamburger menu
	--------------------------------------------------------------*/
	.menu-btn {
		display: none;
		width: 30px;
		height: 19px;
        left: 15px;
        position: fixed;
        top: 82px;
		z-index: 110;
		cursor: pointer;

		&::after,
		&::before,
		span {
			width: 100%;
			height: 3px;
			position: absolute;
			display: block;
			background-color: $fiord;
		}

		&::after,
		&::before {
			content: '';
			transition: $dur width $dur $ease;
		}

		&::after {
			top: 0;
			left: 0;
		}

		&::before {
			bottom: 0;
			right: 0;
		}

		span {
			top: 50%;
			margin-top: -1.5px;
			transition: transform $dur $ease;

			&::before {
				content: '';
				background-color: $fiord;
				width: 100%;
				height: 3px;
				position: absolute;
				left: 0;
				z-index: 1;
				transition: transform $dur $ease;
			}
		}

		&.open {
			&::after,
			&::before {
				transition: $dur $ease;
				width: 0;
				background-color: $fiord;
			}

			&::after {
				left: 0;
			}

			&::before {
				right: 0;
			}

			span {
				background-color: $fiord;
				transform: rotate(45deg);
				transition: $dur transform $dur $ease;

				&::before {
					background-color: $fiord;
					transform: rotate(-90deg);
					transition: $dur transform $dur $ease;
				}
			}
		}

		@include mq($xl) {
			display: block;
			top: 20px;
			z-index: 999999;
		}
	}

	.admin-sidebar-list-item__link--drop {
		cursor: pointer;
	}
</style>
